<p-confirmpopup></p-confirmpopup>
<div class="card">
  @if (rows$ | async; as Data) {
    <p-table [value]="Data" editable="true" scrollable scrollDirection="horizontal" [style]="{ width: '100%' }"
      [totalRecords]="totalRecords"
      [paginator]="true" #dt2 [rows]="tablePageSize" [tableStyle]="{ 'min-width': '50rem' }"
      [first]="(pageNumber - 1) * tablePageSize"
      [globalFilterFields]="getColumnFields()" [rowsPerPageOptions]="rowsPerPageOptions" paginatorDropdownAppendTo="body"
      [selection]="selectedRows" [ngClass]="{ 'p-table-striped': ShowAlternateRowColor}"
      (onEditComplete)="onRowEditComplete($event)" (onRowSelect)="onRowSelect($event)" (onPage)="onPageChanged($event)"
      (onRowUnselect)="onRowUnselect($event)" (selectionChange)="onSelectionChange($event)" editMode="row" dataKey="id"
      appendTo="body"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [lazy]="true"
      (onLazyLoad) = "loadData($event)"
      [customSort] = "true"
      (sortFunction) = "loadData($event)"
      >
      <ng-template pTemplate="caption">
        <div class="table-wrapper">
          <span class="p-input-icon-left ml-auto">
            <input
              pInputText
              type="text"
              [(ngModel)]="searchValue"
              (blur)="filterTable(searchValue)"
              placeholder="Search keyword"
              />
            </span>
            <div class="download-container-right">
              @for (btn of actionButtons; track btn) {
                <div>
                  @if (btn.id === '1') {
                    <button class="grid-button" (click)="onAction1ButtonClick($event)" pButton
                    icon="{{ btn.icons }}" title="{{ btn.title }}"></button>
                  }
                  @if (btn.id === '2') {
                    <button class="grid-button" (click)="onAction2ButtonClick($event)" pButton
                    icon="{{ btn.icons }}" title="{{ btn.title }}"></button>
                  }
                  @if (btn.id === '3') {
                    <button class="grid-button" (click)="onAction3ButtonClick($event)" pButton
                    icon="{{ btn.icons }}" title="{{ btn.title }}"></button>
                  }
                  @if (btn.id === '4') {
                    <button class="grid-button" (click)="onAction4ButtonClick($event)" pButton
                    icon="{{ btn.icons }}" title="{{ btn.title }}"></button>
                  }
                  @if (btn.id === '5') {
                    <button class="grid-button" (click)="onAction5ButtonClick($event)" pButton
                    icon="{{ btn.icons }}" title="{{ btn.title }}"></button>
                  }
                </div>
              }
            </div>
          </div>
        </ng-template>
        <!-- Table Header -->
        <ng-template pTemplate="header">
          <tr>
            @if (showCheckRowColumn === true) {
              <th style="width: 3rem">
                <!-- Checkbox for select all -->
                @if (SingleRowSelection !== true && showCheckAll === true) {
                  <p-tableCheckbox></p-tableCheckbox>
                }
              </th>
            }
            @for (col of columns; track col) {
              <th [pSortableColumn]="col.field" [style.width]="col.width"
                aria-hidden="col.isVisible === false">
                @if (col.isVisible !== false) {
                  <span> {{ col.header }}
                    @if (col.type !== 'action') {
                      <p-sortIcon [field]="col.field"></p-sortIcon>
                    }
                  </span>
                }
              </th>
            }
          </tr>
        </ng-template>
        <!-- Table Body -->
        <ng-template pTemplate="body" let-row let-i="rowIndex">
          <tr>
            <!-- Row checkbox for selection -->
            @if (showCheckRowColumn === true) {
              <td>
                @if (SingleRowSelection === true) {
                  <p-tableRadioButton [value]="row" name="single"></p-tableRadioButton>
                }
                @if (SingleRowSelection !== true) {
                  <p-tableCheckbox [value]="row"></p-tableCheckbox>
                }
              </td>
            }
            @for (col of columns; track col) {
              <td [pEditableColumn]="row" width="{{col.width}}" height="80%"
                aria-hidden="col.isVisible !== false" style="white-space: pre-wrap;">
                @if (col.type === 'checkbox') {
                  <p-checkbox [(ngModel)]="row[col.field]"></p-checkbox>
                } @else {
                  @if (col.type === 'editableCheckboxColumn') {
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-checkbox [(ngModel)]="row[col.field]" pInputCheckbox></p-checkbox>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <p-checkbox [(ngModel)]="row[col.field]" pInputCheckbox></p-checkbox>
                      </ng-template>
                    </p-cellEditor>
                  }
                  @if (col.type === 'editableInputTextAreaColumn') {
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <textarea [(ngModel)]="row[col.field]" wrap="hard" type="text" style="text-wrap:wrap;"
                        pInputTextarea></textarea>
                      </ng-template>
                      <ng-template pTemplate="output"
                        style="white-space: normal; word-wrap: break-word; word-break: break-word; ">
                        <span> {{ row[col.field] }}</span>
                      </ng-template>
                    </p-cellEditor>
                  }
                  @if (col.type === 'editableInputNumberColumn') {
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input [(ngModel)]="row[col.field]" pInputNumber type="number" />
                      </ng-template>
                      <ng-template pTemplate="output" style="width: 100%;">
                        {{ row[col.field] }}
                      </ng-template>
                    </p-cellEditor>
                  }
                  @if (col.type === 'editableInputTextColumn') {
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input [(ngModel)]="row[col.field]" type="text" style="width: 100%;" pInputTextarea />
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ row[col.field] }}
                      </ng-template>
                    </p-cellEditor>
                  }
                  @if (col.type === 'editableDropdownColumn') {
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-select pSelect [options]="col.options" appendTo="body" [(ngModel)]="row[col.field]"
                        [style]="{'width':'100%'}"></p-select>
                      </ng-template>
                      <ng-template pTemplate="output">
                        @for (o of getOptionsLabelDesc(col.options, row[col.field]); track o) {
                          <div>
                            <span title="{{ o.desc }}"> {{ o.label }}</span>
                          </div>
                        }
                      </ng-template>
                    </p-cellEditor>
                  }
                  @if (col.type === 'editableCheckboxColumn') {
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-checkbox [(ngModel)]="row[col.field]"></p-checkbox>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ row[col.field] }}
                      </ng-template>
                    </p-cellEditor>
                  }
                  @if ((col.type === undefined || col.type === '') && (col.isClickable === 'true' )) {
                    <span (click)="cellClicked(col.header, row)" style="cursor: pointer; color: indigo"
                    title="{{ row[col.field] }}">{{ row[col.field] }}</span>
                  }
                  @if ((col.type === undefined || col.type === '') && (col.showDialog !== 'true' ) && (col.trimText !== 'true' )  &&  (col.isClickable !== 'true' )) {
                    <span title="{{ row[col.field] }}">{{ row[col.field] }}</span>
                  }
                  @if ((col.type === undefined || col.type === '') && (col.showDialog !== 'true' ) && (col.trimText === 'true' )) {
                    <span title="{{ row[col.field] }}">{{ row[col.field].length > 25 ? row[col.field].substr(0, 25) + "..." :
                    row[col.field] }}</span>
                  }
                  @if ((col.type === undefined || col.type === '') && (col.showDialog === 'true' ) && (col.trimText === 'true' )) {
                    <span (click)="cellClicked(col.header, row)" style="cursor: pointer; color: indigo"
                      title="{{ row[col.field] }}">{{ row[col.field].length > 25 ? row[col.field].substr(0, 25) + "..." :
                    row[col.field] }}</span>
                  }
                  @if ((col.type === 'action' )) {
                    <a class="action-link" title="{{col.field}}" (click)="col.onclick(row)">{{ col.field }}</a>
                  }
                }
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    }
  </div>
